import React from "react";
import { useTranslation } from "react-i18next";
import Eyebrow from "../../atoms/Eyebrow/Eyebrow.styled";
import CustomerCard from "../../atoms/CustomerCard/CustomerCard.component";
import { getCustomersTranslated } from "../../../constants/customers";
import { newLineText } from "../../../utils/utils";
import {
  CustomerGrid,
  CustomersSection,
  CustomersTitle,
  CustomersWrapper,
  EvidenceHeading,
} from "./CustomerStories.styled";

const CustomerStories = () => {
  const { t } = useTranslation();
  const customers = getCustomersTranslated(t);
  const linkedinLabel = t("landing.customers.linkedinCta");

  return (
    <CustomersSection id="customers" aria-labelledby="customers-title">
      <CustomersWrapper>
        <EvidenceHeading>
          <div>
            <Eyebrow>{t("landing.customers.eyebrow")}</Eyebrow>
            <CustomersTitle id="customers-title">
              {newLineText(t("landing.customers.title")).map((line) => (
                <span key={line}>{line}</span>
              ))}
            </CustomersTitle>
          </div>
        </EvidenceHeading>
        <CustomerGrid>
          {customers.map((customer) => (
            <CustomerCard
              key={customer.id}
              name={customer.name}
              role={customer.role}
              quote={customer.quote}
              linkedinUrl={customer.linkedinUrl}
              linkedinLabel={linkedinLabel}
            />
          ))}
        </CustomerGrid>
      </CustomersWrapper>
    </CustomersSection>
  );
};

export default CustomerStories;
